import PageCommon from "./../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";

export default class PageList extends PageCommon {
	constructor() {
		super();
	}
	init($data) {
		super.init($data);
		this.data = $data;
		this.showPreloader(false);
		//
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.tableSUid, SecurityAcl.ACL_CREATE))) {
			$(".jsBtnNew").on("click", this.onAdd.bind(this))
		} else {
			$(".jsBtnNew").remove();
		}


		// 
		this.initList();

		if (this.initAgList) {
			this.initAgList();
		}


		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
	}

	initListButton(ev) {
		// eventType, gridWrp, dataIndex, dataRow, mcCol
		// alert(this.data.tableSUid + ev.dataRow.Value);
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_DELETE))) {
			$(".btnDelete", ev.mcCol).on("click", this.onDelete.bind(this, ev.dataIndex));
		} else {
			$(".btnDelete", ev.mcCol).remove();
		}
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_READ))) {
			$(".btnView", ev.mcCol).on("click", this.onNavigate.bind(this, ev.dataIndex));
		} else {
			$(".btnView", ev.mcCol).remove();
		}
		
	}


	onDelete(dataIndex) {
		let modal = new ModalConfirm($("#template-modalConfirm"));
		modal.create(
			{
				title: "Conferma cancellazione",
				body: "Sei sicuro di voler rimuovere definitivamente questo elemento? Non puoi annullare questa azione.",
				yes: "SI",
				no: "NO",
				danger:true // viene il pulsante rosso, altrimenti blue
			}, this.onConfirmDelete.bind(this, dataIndex));
		modal.init();
	}

	onConfirmDelete(dataIndex, bConfirm) {
		if (bConfirm) {
			// this.theGrid.deleteByDataIndex(dataIndex)
			this.showPreloader(true);
			let rq = {
				Value: this.theGrid.data[dataIndex].Uid
			}
			thatServiceManeger.standardCall(this.data.serviceDeleteRoute + this.data.tableUid, rq, this.onDeleteServiceHandler.bind(this, dataIndex));
		}
	}

	onDeleteServiceHandler(dataIndex, rs) { 
		this.showPreloader(false);
		//
		if (rs.Success) {
			this.theGrid.deleteByDataIndex(dataIndex);
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "Successo",
					body: "Cancellazione terminata correttamente!",
					close: "CHIUDI",
					error: false
				});
			modal.init();
		} else {
			let error = null;
			if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
				error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
				if (rs.Errors[0].RefsUid.length > 0) {
					error = error.replace("{0}", rs.Errors[0].RefsUid);
				}
			}
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "Si è verificato un'errore",
					body: error,
					close: "CHIUDI",
					error: true
				});
			modal.init();
		}
		//this.showPreloader(false);
	}

	onNavigate(dataIndex) {
		document.location.href = TheApp.Env.BaseUrlNls + "lookup/" + this.data.tableUid.toLowerCase() + "/detail/" + Base64.toBase64(this.theGrid.data[dataIndex].Value,true) + "?__pi=" + this.data.page.PageId;
	}

	onAdd() {
		document.location.href = TheApp.Env.BaseUrlNls + "lookup/" + this.data.tableUid.toLowerCase() + "/detail" + "?__pi=" + this.data.page.PageId;
	}

	initList() {
		console.log("PageList::initShieldCommonComponents to override");
	}


}

